<template>
    <div>
    <v-card
        color="grey lighten-4"
        
    >
    <v-toolbar dense>
      <v-app-bar-nav-icon></v-app-bar-nav-icon>

      <v-toolbar-title>{{user.name}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text @click="logout">
        <v-icon>mdi-logout-variant</v-icon> Salir
      </v-btn>
      
    </v-toolbar>
  </v-card>
    <v-overlay :value="overlay">
    <v-progress-circular
        indeterminate
        :absolute=false
        size="64"
    ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
    import {mapActions, mapMutations, mapState } from 'vuex'

    export default {
        name: 'NavPublicComponent',
        data: () =>({
            overlay:false
        }),
		computed:{
            ...mapState(['user','token']),
            
            loggedIn(){
                return this.$store.getters.getIsLoggedIn
            },
		},
        methods:{
            ...mapMutations(['setUrl','setLogedIn','setActionsRol']),

            ...mapActions(['requestApi','errorRequest']),

            logout(){
                this.setUrl('user-laboratorio')
                this.overlay=true
                this.requestApi({
                    method:'DELETE',
                    data:{
                        access_token: this.token,
                        userLoginId : this.user.user_ligin_id,
                        dataBase : 'obinnoclinica',
                        system: 'laboratorio',
                        comment: 'ha cerrado sesión en el sistema de consultas de examenes médicos del laboratorio'
                    }
                }).then(res =>{

                    localStorage.removeItem('token')
                    localStorage.setItem('user','')
                    this.setLogedIn(false)
                    this.setActionsRol()
                    if(!this.loggedIn)
                        this.$router.push('/')
                        this.overlay=false
                }).catch(err =>{
                
                    let response = err.response;
                    this.errorRequest({
                        data : {
                            datos: response.data.errors,
                            status : response.status,
                        }
                    });
                    this.overlay=false

                });
            },
        }
    }
</script>
